import _classCallCheck from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * DevExtreme (esm/exporter/exceljs/export_merged_ranges_manager.js)
 * Version: 21.1.12
 * Build date: Fri Apr 07 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";

var MergedRangesManager =
/*#__PURE__*/
function () {
  function MergedRangesManager(dataProvider, helpers, mergeRowFieldValues, mergeColumnFieldValues) {
    _classCallCheck(this, MergedRangesManager);

    this.mergedCells = [];
    this.mergedRanges = [];
    this.dataProvider = dataProvider;
    this.helpers = helpers;
    this.mergeRowFieldValues = mergeRowFieldValues;
    this.mergeColumnFieldValues = mergeColumnFieldValues;
  }

  _createClass(MergedRangesManager, [{
    key: "updateMergedRanges",
    value: function updateMergedRanges(excelCell, rowIndex, cellIndex) {
      if (this.helpers._isHeaderCell(this.dataProvider, rowIndex, cellIndex)) {
        if (!this.isCellInMergedRanges(rowIndex, cellIndex)) {
          var _this$dataProvider$ge = this.dataProvider.getCellMerging(rowIndex, cellIndex),
              rowspan = _this$dataProvider$ge.rowspan,
              colspan = _this$dataProvider$ge.colspan;

          var isMasterCellOfMergedRange = colspan || rowspan;

          if (isMasterCellOfMergedRange) {
            var allowToMergeRange = this.helpers._allowToMergeRange(this.dataProvider, rowIndex, cellIndex, rowspan, colspan, this.mergeRowFieldValues, this.mergeColumnFieldValues);

            this.updateMergedCells(excelCell, rowIndex, cellIndex, rowspan, colspan, allowToMergeRange);

            if (allowToMergeRange) {
              this.mergedRanges.push(_extends({
                masterCell: excelCell
              }, {
                rowspan: rowspan,
                colspan: colspan
              }));
            }
          }
        }
      }
    }
  }, {
    key: "isCellInMergedRanges",
    value: function isCellInMergedRanges(rowIndex, cellIndex) {
      return this.mergedCells[rowIndex] && this.mergedCells[rowIndex][cellIndex];
    }
  }, {
    key: "findMergedCellInfo",
    value: function findMergedCellInfo(rowIndex, cellIndex) {
      if (this.helpers._isHeaderCell(this.dataProvider, rowIndex, cellIndex)) {
        if (this.isCellInMergedRanges(rowIndex, cellIndex)) {
          return this.mergedCells[rowIndex][cellIndex];
        }
      }
    }
  }, {
    key: "updateMergedCells",
    value: function updateMergedCells(excelCell, rowIndex, cellIndex, rowspan, colspan, allowToMergeRange) {
      for (var i = rowIndex; i <= rowIndex + rowspan; i++) {
        for (var j = cellIndex; j <= cellIndex + colspan; j++) {
          if (!this.mergedCells[i]) {
            this.mergedCells[i] = [];
          }

          this.mergedCells[i][j] = {
            masterCell: excelCell,
            unmerged: !allowToMergeRange
          };
        }
      }
    }
  }, {
    key: "applyMergedRages",
    value: function applyMergedRages(worksheet) {
      this.mergedRanges.forEach(function (range) {
        var startRowIndex = range.masterCell.fullAddress.row;
        var startColumnIndex = range.masterCell.fullAddress.col;
        var endRowIndex = startRowIndex + range.rowspan;
        var endColumnIndex = startColumnIndex + range.colspan;
        worksheet.mergeCells(startRowIndex, startColumnIndex, endRowIndex, endColumnIndex);
      });
    }
  }]);

  return MergedRangesManager;
}();

export { MergedRangesManager };